'use client';

import dynamic from 'next/dynamic';
import type { IConsentAlertProps } from './ConsentAlert';

/**
 * The alert only ever appears after a user interaction, so it stays off the
 * login critical path. The placeholder reserves its height to avoid a shift
 * once the chunk lands.
 */
export const DeferredConsentAlert: React.ComponentType<IConsentAlertProps> = dynamic(
    () => import('./ConsentAlert').then((module) => module.ConsentAlert),
    {
        ssr: false,
        loading: () => (
            <div
                className="invisible mt-5 h-[75px] w-full max-w-[400px]"
                aria-hidden="true"
                data-testid="consent-alert-placeholder"
            />
        ),
    }
);
